export interface NormalizeOpaqueLongIdOptions {
  allowNegative?: boolean
}

/**
 * Keep backend Long identifiers as decimal strings. Unsafe JavaScript numbers
 * are rejected because their original digits have already been lost.
 */
export function normalizeOpaqueLongId(
  value: unknown,
  options: NormalizeOpaqueLongIdOptions = {},
): string | undefined {
  const allowNegative = options.allowNegative === true
  if (typeof value === "number") {
    if (!Number.isSafeInteger(value) || value === 0 || (!allowNegative && value < 0)) {
      return undefined
    }
    return String(value)
  }
  if (typeof value !== "string") return undefined

  const normalized = value.trim()
  const pattern = allowNegative ? /^-?[1-9]\d*$/ : /^[1-9]\d*$/
  return pattern.test(normalized) ? normalized : undefined
}
